module.exports = __webpack_public_path__ + "media/Loops 110 Drums.8a8e696b.wav";